import {
  DialogTitle,
  Stack,
  IconButton,
} from '@mui/material'
import {useResponsive} from 'src/hooks/use-responsive'
import CloseIcon from '@mui/icons-material/Close';
import ChevronLeft from '@mui/icons-material/ChevronLeft';

const DialogHeaderNested = ({
  children,
  close,
  back,
  sx
}) => {

  const smUp = useResponsive('up', 'sm');

  return (
    <DialogTitle
      sx={{
        padding: "20px",
        ...(smUp && {
          minHeight: '84px',
        }),
        ...sx,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        {back && (
          <IconButton size="large" onClick={back}>
            <ChevronLeft size="small" />
          </IconButton>
        )}
        {children}
        <IconButton size="large" onClick={close}>
          <CloseIcon />
        </IconButton>
      </Stack>
    </DialogTitle>
  )
}

export default DialogHeaderNested
